"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AnimatedClock = _styledComponents.default.circle.withConfig({
  displayName: "clock__AnimatedClock",
  componentId: "sc-8k6sl4-0"
})(["fill:transparent;opacity:", ";stroke:", ";stroke-width:32;stroke-dasharray:", ";"], function (_ref) {
  var opacity = _ref.opacity;
  return opacity;
}, function (_ref2) {
  var primaryColor = _ref2.primaryColor;
  return primaryColor;
}, function (_ref3) {
  var progressPercentage = _ref3.progressPercentage;
  return "".concat(progressPercentage, " 100");
});

var _default = AnimatedClock;
exports.default = _default;